import { Suspense, lazy } from "react";

import { Route } from "react-router-dom";

import BasicLayout from "shared/templates/Layouts/BasicLayout";
import type { IApp } from "shared/types";

const HomePage = lazy(() => import("./Pages/Home"));
const InfoPage = lazy(() => import("./Pages/Info"));
const SupportPage = lazy(() => import("./Pages/Support"));
// const TournamentsPage = lazy(() => import("./Pages/Tournaments"));
const PromotionsPage = lazy(() => import("./Pages/Promotions"));
const NotFoundPage = lazy(() => import("./Pages/NotFound"));

import { routes } from "./constants";

class MemberApp implements IApp {
	getRoutes = () => [
		<Route key="member-routes">
			<Route key="member-routes" element={<BasicLayout />}>
				<Route
					key={"home-default"}
					path={"/"}
					element={
						<Suspense>
							<HomePage />
						</Suspense>
					}
				/>
				<Route
					key={routes.home.getElementKey()}
					path={routes.home.getPath()}
					element={
						<Suspense>
							<HomePage />
						</Suspense>
					}
				/>
				<Route
					key={routes.info.getElementKey()}
					path={routes.info.getPath()}
					element={
						<Suspense>
							<InfoPage />
						</Suspense>
					}
				/>
				<Route
					key={routes.contactUs.getElementKey()}
					path={routes.contactUs.getPath()}
					element={
						<Suspense>
							<SupportPage />
						</Suspense>
					}
				/>
				{/*<Route*/}
				{/*	key={routes.tournaments.getElementKey()}*/}
				{/*	path={routes.tournaments.getPath()}*/}
				{/*	element={*/}
				{/*		<Suspense>*/}
				{/*			<TournamentsPage />*/}
				{/*		</Suspense>*/}
				{/*	}*/}
				{/*/>*/}
				<Route
					key={routes.promotions.getElementKey()}
					path={routes.promotions.getPath()}
					element={
						<Suspense>
							<PromotionsPage />
						</Suspense>
					}
				/>
				<Route
					key={"not-found"}
					path={"/404"}
					element={
						<Suspense>
							<NotFoundPage />
						</Suspense>
					}
				/>
			</Route>
		</Route>
	];
}

export default MemberApp;
